module.exports = __webpack_public_path__ + "static/media/sk.daf75e75.svg";